import { render, staticRenderFns } from "./stepper_product.vue?vue&type=template&id=58f532dc&"
import script from "./stepper_product.vue?vue&type=script&lang=js&"
export * from "./stepper_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports